module.exports = __webpack_public_path__ + "img/tile-keyframes-desktop_en.d10c6ff.jpg";